export default __webpack_public_path__ + "static/media/Rectangle_87.c3c41e42.png";